<t-llevo-dialog-header
  [dialogTitle]="dialogTitle()"
  mat-dialog-title
></t-llevo-dialog-header>
<mat-dialog-content>
  <mat-stepper [linear]="_edit() ? false : true" #stepper>
    <mat-step [stepControl]="generalFrm" label="General">
      <form
        commonui-loader
        [appLoader]="loading() ?? false"
        [formGroup]="generalFrm"
        class="row pt-2"
      >
        <mat-form-field class="mb-3 col-12">
          <mat-label>Tipo de vehículo</mat-label>
          <mat-select formControlName="vehicleType">
            @for (type of availableVehicleTypes$ | async; track type) {
            <mat-option [value]="type.id">{{ type.name }}</mat-option>
            }
          </mat-select>
          @if (vehicleType.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="mb-3 col-12">
          <mat-label>Moneda</mat-label>
          <mat-select formControlName="currency">
            @for (currency of availableCurrency; track currency) {
            <mat-option [value]="currency">{{ currency }}</mat-option>
            }
          </mat-select>
          @if (currency.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Tarifa base</mat-label>
          <input matInput formControlName="baseFee" type="number" min="0" />
          @if (baseFee.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
          }
        </mat-form-field>

        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Costo por Km</mat-label>
          <input matInput formControlName="costPerKm" type="number" min="0" />
          @if (costPerKm.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
          }
          <mat-hint> Tarifa por kilómetro recorrido </mat-hint>
        </mat-form-field>
      </form>
      <div class="d-flex justify-content-end">
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="extraFrm" label="Opcional">
      <form
        commonui-loader
        [appLoader]="loading() ?? false"
        [formGroup]="extraFrm"
        class="row pt-2"
      >
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Costo por minuto</mat-label>
          <input
            matInput
            formControlName="costPerMinute"
            type="number"
            min="0"
          />
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Costo fijo por recoger</mat-label>
          <input matInput formControlName="pickupFee" type="number" min="0" />
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Costo fijo por dejar</mat-label>
          <input matInput formControlName="dropoffFee" type="number" min="0" />
          <mat-hint>Aplicable a entregas</mat-hint>
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Multiplicador dinámico</mat-label>
          <input
            matInput
            formControlName="surgeMultiplier"
            type="number"
            min="1"
          />
          @if (surgeMultiplier.hasError('min')) {
          <mat-error>El multiplicador debe ser superior a 1</mat-error>
          }
          <mat-hint>Multiplicador aplicable en horas de alta demanda</mat-hint>
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Tarifa mínima total</mat-label>
          <input matInput formControlName="minimumFare" type="number" min="0" />
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Penalización por cancelación</mat-label>
          <input
            matInput
            formControlName="cancellationFee"
            type="number"
            min="0"
          />
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Distancia base</mat-label>
          <input
            matInput
            formControlName="distanceThresholdKm"
            type="number"
            min="0"
          />
          <mat-hint>Distancia base incluida en la tarifa base</mat-hint>
        </mat-form-field>
      </form>
      <div class="d-flex justify-content-between">
        <button mat-button matStepperPrevious>Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step
      [stepControl]="ruleFrm"
      label="Regla"
      commonui-loader
      [appLoader]="loading() ?? false"
    >
      <form [formGroup]="ruleFrm" class="row pt-2">
        <mat-form-field class="mb-3 col-12">
          <mat-label>Día de la semana</mat-label>
          <mat-select formControlName="weekDay">
            @for (day of weekDaysList; track day) {
            <mat-option [value]="day.value.toString()">{{
              day.label
            }}</mat-option>
            }
            <mat-option [value]="null"> Ninguno </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Inicio de periodo de validez</mat-label>
          <input
            matInput
            [matTimepicker]="pickerStart"
            formControlName="validTimeRangeStart"
          />
          <mat-timepicker-toggle matIconSuffix [for]="pickerStart" />
          <mat-timepicker #pickerStart />
          @if(validTimeRangeStart.errors?.['requireBothIfOneIsFilled']){
          <mat-error> Complete ambos campos si uno tiene un valor. </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mb-3 col-12 col-md-6">
          <mat-label>Fin del periodo de validez</mat-label>
          <input
            matInput
            [matTimepicker]="pickerEnd"
            formControlName="validTimeRangeEnd"
          />
          <mat-timepicker-toggle matIconSuffix [for]="pickerEnd" />
          <mat-timepicker #pickerEnd />
          @if(validTimeRangeEnd.errors?.['requireBothIfOneIsFilled']){
          <mat-error> Complete ambos campos si uno tiene un valor. </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="mb-3 col-12">
          <mat-label>Geofence</mat-label>
          <textarea matInput formControlName="geofence"></textarea>
          @if (geofence.hasError('required')) {
          <mat-error>Campo requerido</mat-error>
          }
        </mat-form-field>
      </form>
      <div class="d-flex justify-content-end">
        <button mat-flat-button (click)="onSubmit()">{{ submitBtn() }}</button>
      </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
